/**
 * Maximum Length Validation for Correctly Counting Surrogate Pair Characters
 */
export const maxLengthWithSurrogate = (maxLength: number, message: string) => ({
  validate: {
    maxLength: (
      value: string | number | boolean | undefined
    ): boolean | string => {
      if (typeof value !== 'string') return true;
      const actualLength = [...value].length;
      return actualLength <= maxLength || message;
    },
  },
});
